import React, { useState } from "react";
import Slider from "react-slick";
import styled from "styled-components";
import ResponsiveImage from "src/components/ImageWrapper/ResponsiveImage";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ImageCarousel = ({
  images = [],
  autoplay = true,
  autoplaySpeed = 5000,
  speed = 700,
  arrows = false,
  dots = false,
  infinite = true,
  slidesToShow = 1,
  slidesToScroll = 1,
  responsive = [],
  initialSlide = 0,
  dotsBottom = "20px",
}) => {
  const [slideRight, setSlideRight] = useState(true);
  const [currentSlide, setCurrentSlide] = useState(initialSlide);

  const settings = {
    dots: false, // Using custom dots instead
    arrows,
    infinite,
    lazyLoad: true,
    autoplay,
    autoplaySpeed,
    speed,
    slidesToShow,
    slidesToScroll,
    responsive,
    initialSlide,
    beforeChange: (prev, next) => slideIndexChange(prev, next),
  };

  const slideIndexChange = (prev, next) => {
    setCurrentSlide(next);
    const totalSlides = images.length - 1;
    if (next > prev) {
      setSlideRight(true);
    } else if (next < prev && prev === totalSlides && next === 0) {
      setSlideRight(true);
    } else {
      setSlideRight(false);
    }
  };

  return (
    <CarouselWrapper slide={slideRight}>
      <Slider {...settings}>
        {images.map((image, index) => (
          <SlideItem key={index}>
            <ResponsiveImage
              src={image.src}
              alt={image.alt || `Slide ${index + 1}`}
            />
          </SlideItem>
        ))}
      </Slider>
      {dots && (
        <DotsContainer $bottom={dotsBottom}>
          {images.map((_, index) => (
            <Dot key={index} active={index === currentSlide} />
          ))}
        </DotsContainer>
      )}
    </CarouselWrapper>
  );
};

const CarouselWrapper = styled.div`
  width: 100%;
  position: relative;

  .slick-track {
    cursor: pointer;
    display: flex;
  }

  .slick-slider {
    width: 100%;
  }

  .slick-slide {
    outline: none;

    > div {
      outline: none;
    }
  }

  .slick-list {
    overflow: hidden;
  }

  .slick-dots {
    display: none !important;
  }
`;

const SlideItem = styled.div`
  padding: 0 5px;
  outline: none;

  img {
    width: 100%;
    height: auto;
    display: block;
  }
`;

const DotsContainer = styled.ul`
  position: absolute;
  bottom: ${props => props.$bottom || "20px"};
  left: 50%;
  transform: translateX(-50%);
  padding: 0 10px;
  margin: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 35px;
  border-radius: 20px;
  background: rgba(0, 0, 0, 0.7);
  box-shadow:
    0 2px 4px 0 rgba(0, 0, 0, 0.4),
    0 1px 3px 0 rgba(0, 0, 0, 0.2);
  list-style-type: none;

  @media (min-width: 768px) {
    display: none;
  }
`;

const Dot = styled.li`
  margin: 0;
  padding: ${(props) => (props.active ? "6px" : "5px")};
  border-radius: 50%;
  background: ${(props) => (props.active ? "var(--grey)" : "var(--lightgrey)")};
  transition: all 0.3s ease;
`;

export default ImageCarousel;
